module.exports = __webpack_public_path__ + "img/hc_pro_two_6.6524a07a.jpg";